import { createContext } from 'react';

export type ConnectCreditCardCtx = {
  showConnectCreditCardSuccessAlert: boolean;
  showConnectCreditCardErrorAlert: boolean;
  showConnectSameCreditCardErrorAlert: boolean;
  showConnectCreditCardFailAlert: boolean;
  connectCreditCardError: string;
  connectCreditCardErrorTitle?: string;
};

const ConnectCreditCardContext = createContext<ConnectCreditCardCtx>({
  showConnectCreditCardSuccessAlert: false,
  showConnectCreditCardErrorAlert: false,
  showConnectSameCreditCardErrorAlert: false,
  showConnectCreditCardFailAlert: false,
  connectCreditCardError: '',
  connectCreditCardErrorTitle: undefined,
});

export default ConnectCreditCardContext;
